export default __webpack_public_path__ + "static/media/chrome-quick-location-enabling.8d5bcaab.png";